import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {lazy} from 'react';
import './assets/styles/main.scss';
import PrivateRoute from './components/privateRoute';
import './styles.css';
import ReactGA from 'react-ga4';

import Copyright from './components/copyright';
import ChatWidget from './components/ChatWidget';

const TRACKING_ID = process.env.REACT_APP_GA_ID;

if (TRACKING_ID) {
  ReactGA.initialize(TRACKING_ID);
}

const LogIn = lazy(()=> import('./pages/authViews/logIn'));
const ResetPwd = lazy(()=> import('./pages/authViews/resetPassword'));
const PwdReestablishment = lazy(()=> import('./pages/authViews/restorePassword'));
const SignUp = lazy(()=> import('./pages/authViews/signUp'));
const ConfirmationResetedPwd = lazy(()=> import('./pages/authViews/confirmationForgotPassword'));
const ConfirmRestoredPwd = lazy(()=> import('./pages/authViews/confirmResetPassword'));

const AnalystInput = lazy(()=> import('./pages/algoInputViews/analysts'));
const BlackLitInput = lazy(()=> import('./pages/algoInputViews/bl'));
const FundamentalInput = lazy(()=> import('./pages/algoInputViews/fundamentals'));
const OptimizationInput = lazy(()=> import('./pages/algoInputViews/optimizations'));
const PaInput = lazy(()=> import('./pages/algoInputViews/pa'));
const PmInput = lazy(()=> import('./pages/algoInputViews/pmStocks'));
const ReportInput = lazy(()=> import('./pages/algoInputViews/report'));
const SignalToNoiseInput = lazy(()=> import('./pages/algoInputViews/stn'));
const VarInput = lazy(()=> import('./pages/algoInputViews/var'));

const Algorithms = lazy(()=> import('./pages/mainViews/algorithms'));
const HelpSection = lazy(()=> import('./pages/mainViews/helpSection'));
const Landing = lazy(()=> import('./pages/mainViews/landing'));
const Release = lazy(()=> import('./pages/mainViews/releases'));
const SavedSim = lazy(()=> import('./pages/mainViews/savedSimulations'));
const FinancialData = lazy(()=> import('./pages/mainViews/stockViewer'));

const CancelledPayment = lazy(()=> import('./pages/paymentViews/cancelledPayment'));
const SuccessPayment = lazy(()=> import('./pages/paymentViews/successPayment'));

const ConfirmedDeletedAccount = lazy(()=> import('./pages/userViews/confirmDelete'));
const MyProfile = lazy(()=> import('./pages/userViews/me'));

const NotFound = lazy(()=> import('./pages/otherViews/pageNotFound'));

function App() {

  return (
    <>
      {/* Use to override MUI's styles. */}
      <StyledEngineProvider injectFirst>
        <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
          <Routes>
            {/* Public auth routes */}
            <Route path='/' exact element={<Landing />} />
            <Route path='/login' exact element={<LogIn />} />
            <Route path='/signUp' exact element={<SignUp />} />
            <Route path='/restorePassword' exact element={<PwdReestablishment />} />
            <Route path='/confirmationRestorePassword' exact element={<ConfirmRestoredPwd />} />
            
            {/* Stripe payment redirect routes - MUST be public and not wrapped */}
            <Route path='/successPayment' element={<SuccessPayment />} />
            <Route path='/cancelPayment' element={<CancelledPayment />} />

            {/* Public info routes */}
            <Route path='/algorithms' exact element={<Algorithms />} />
            <Route path='/help-section' exact element={<HelpSection />} />
            <Route path='/releases' exact element={<Release />} />

            {/* Protected routes - all inside PrivateRoute */}
            <Route element={<PrivateRoute />}>
              <Route path='/resetPassword/:token' element={<ResetPwd />} />
              <Route path='/confirmationPasswordReset' element={<ConfirmationResetedPwd />} />
              <Route path='/YourProfile' element={<MyProfile />} />
              <Route path='/confirmedDeletedAccount' element={<ConfirmedDeletedAccount />} />
              <Route path='/algorithms/fundamental' element={<FundamentalInput />} />
              <Route path='/algorithms/analysts' element={<AnalystInput />} />
              <Route path='/algorithms/pm-stocks' element={<PmInput />} />
              <Route path='/algorithms/optimization' element={<OptimizationInput />} />
              <Route path='/algorithms/var' element={<VarInput />} />
              <Route path='/algorithms/report' element={<ReportInput />} />
              <Route path='/algorithms/stn' element={<SignalToNoiseInput />} />
              <Route path='/algorithms/bl' element={<BlackLitInput />} />
              <Route path='/algorithms/pa' element={<PaInput />} />
              <Route path='/financial-data' exact element={<FinancialData />} />
              <Route path='/savedSimulations' element={<SavedSim />} />
            </Route>

            {/* 404 route */}
            <Route path='*' element={<NotFound />} />
          </Routes>
          <ChatWidget />
        </BrowserRouter>
        <Copyright />
      </StyledEngineProvider>
    </>
  );
}

export default App;
